import React, { } from "react";
import type * as types from "../PhoenixFormsV4";
import type * as controls from "../PhoenixFormsV4.Controls";
import type * as appData from "../PhoenixFormsV4.AppData";
import PhoenixFormsV4Control from "./PhoenixFormsV4Control";
import PhoenixFormsV4ReadOnlyControl from "./PhoenixFormsV4ReadOnlyControl";
import PhoenixPhotoWizard, { PhoenixPhotoReadOnlyPreview } from "./PhoenixPhotoWizard";
import { usePhoenixFormsDialog, PhoenixFormsDialogValue } from "./usePhoenixFormsDialog";
import PNXLabel from "./PNXLabel";
import { usePhoenixForms } from "../PhoenixFormsProvider";


interface Props {
  controlProps: controls.ContainerControl;
  proxy: types.PhoenixFormsProxy;
  webRuntimeData: appData.WebRuntimeAppData;
  readonly?: boolean;
};

const PhoenixPhoto = ({
  controlProps,
  proxy,
  webRuntimeData,
  readonly,
} : Props) => {

  const { isPreview } = usePhoenixForms();
  const dialog: PhoenixFormsDialogValue = usePhoenixFormsDialog();

  const photoData = proxy.requestPhotoData(controlProps.id);

  let photoStateClassName = "photo-state ";
  let imageUrl = null;
  let notTakenReason = null;
  let notTakenDescription = null;
  let required = false;

  if (photoData.link.shared) {
    photoStateClassName += "state-shared";
  }
  else if (photoData.link.notTaken) {
    photoStateClassName += "state-nottaken";
    notTakenReason = `Not Taken Reason: ${photoData.link.reason}`;
    notTakenDescription = `Not Taken Description: ${photoData.link.description}`;
  }
  else if (photoData.photos.length) {
    photoStateClassName += "state-linked";

    imageUrl = `${webRuntimeData.host}/services/forms4/${webRuntimeData.fileId}/phoenix-editor/${webRuntimeData.sessionKey}/photos/${photoData.photos[0].id}`;
  }
  else {
    photoStateClassName += "state-default";

    if (controlProps.required)
      required = true;
  }

  const photoOnClick = () => {
    if (readonly) {
      if (!photoData.photos.length) return; // we don't actually have any photos, do nothing
      
      dialog.show(<PhoenixPhotoReadOnlyPreview 
        id={controlProps.id}
        photoData={photoData}
        proxy={proxy}
        webRuntimeData={webRuntimeData}
      />);
    }
    else {
      dialog.show(<PhoenixPhotoWizard 
          id={controlProps.id}
          photoData={photoData}
          proxy={proxy}
          webRuntimeData={webRuntimeData}
        />);
    }    
  };

  return <div>
    <div className="photo-header">
      <PNXLabel helpTopicId={!readonly && controlProps.topicId}>{controlProps.label}</PNXLabel>
      <div className="photo-options" onClick={!isPreview && photoOnClick}>
        {imageUrl !== null && 
        <div className="image-container">
          <img src={imageUrl} />
          <div className="image-count">{photoData.photos.length}</div>
        </div>
        }
        <div className={photoStateClassName}></div>
      </div>
    </div>
    {required && <div className="phoenix-validation">{"[ * Required ]"}</div>}
    {notTakenReason !== null && <div>{notTakenReason}</div>}
    {notTakenDescription !== null && <div>{notTakenDescription}</div>}
    <div className="photo-tags">
      {controlProps.controls.map(taggroup => readonly ? 
        <PhoenixFormsV4ReadOnlyControl key={`taggroup-${taggroup.id}`} controlProps={taggroup} parentControlProps={controlProps} /> :
        <PhoenixFormsV4Control key={`taggroup-${taggroup.id}`} controlProps={taggroup} parentControlProps={controlProps} />
      )}
    </div>
  </div>;
};

export default PhoenixPhoto;
